import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { networkErrorHelper } from "libs";
import { withRouter } from "react-router-dom";
import { MTable } from "components/table";
import { Col, Container, Row } from "design-react-kit";
import { revisionService } from "libs/api/revisionService";
import { getCurrentRevisor } from "store/actions";
import { LESSON_ACTIVITY_TYPES, REVISOR_CONTEXTS } from "const";

class ReviewPendingSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rndKey: 0,
      payload: [],
      revisorIdSecurity: null,
      activityType: LESSON_ACTIVITY_TYPES.TFA_CLASSICO,
    };
  }

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "revisionNote",
        Header: "Note revisione",
        accessor: "revisionNote",
      },
    ],
    actions: [],
  };

  //--- ---

  componentDidMount() {
    const revisor = getCurrentRevisor(REVISOR_CONTEXTS.TIROCINIODIRETTO);

    const revisorIdSecurity = revisor?.id;
    if (revisorIdSecurity) {
      this.setState({ revisorIdSecurity });
      this.loadRemote(revisorIdSecurity);
    } else this.loadRemote();
  }

  loadRemote(revisorIdSecurity) {
    this.setState({ loading: true });

    const { status } = this.props.match.params;
    const { activityType } = this.state;

    const filter = {
      status,
      revisorIdSecurity,
      code: "attestatoSicurezza",
      lessonType: "training",
      activityType,
    };

    revisionService
      .listAllSecurityCertificates(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
            loadingError: true,
          });
        }
      });
  }

  //--- ---

  render() {
    const { loading } = this.state;

    return (
      <>
        <Row>
          <Col>
            <Title>Storico Revisioni Non Idonee - Attestati sulla sicurezza</Title>
          </Col>
        </Row>

        <hr />
        <section className="my-4">
          {loading ? (
            <MnemoLoading />
          ) : (
            <Container>
              <MTable key={this.state.rndKey} tableData={this.state.payload} tableConfig={this.tableConfig} />
            </Container>
          )}

          {this.state.payload.length === 0 && (
            <BoxDanger key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare in database.</div>
            </BoxDanger>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewPendingSecurity);
